import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { Risque } from '../models/dossiers/risques';

const resource = 'Risques'

export default class RisquesRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<Risque>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString());

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
